import { render, staticRenderFns } from "./LeftTip.vue?vue&type=template&id=439b0bc2&"
import script from "./LeftTip.vue?vue&type=script&lang=js&"
export * from "./LeftTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports